// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"204":"system","669":"items","709":"order","962":"home","966":"login"}[chunkId] || chunkId) + "." + {"204":"45a48d09","265":"26fcffc5","492":"b4360ccb","624":"3a235576","669":"0e75a9c7","709":"33be73cd","772":"6bad0c35","857":"4fc3b65c","917":"4b6ea447","962":"682fa141","966":"e0f9ef6c"}[chunkId] + ".js";
};